// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"9cc491b8","276":"d8776d66","386":"e421e3a5","409":"245be947","453":"926f0775","592":"ffb51f1f","635":"230958b6","736":"51e052ec","987":"f9f41d31"}[chunkId] + ".chunk.js";
};